import { Map, List } from "immutable";

const targetWindowOpen = window.open;

export const windowOpen = (url, windowName, windowFeatures) =>
  targetWindowOpen(url, windowName, windowFeatures || "");

export const windowOpenPostMessage = (message, targetOrigin) =>
  targetWindowOpen.postMessage(message, targetOrigin || "*");

export const windowParentPostMessage = (message, targetOrigin) =>
  window.parent.postMessage(message, targetOrigin || "*");

export const isListContain = list => List.isList(list) && list.size > 0;
export const isMapContain = map => Map.isMap(map) && map.size > 0;

export const checkIOSMobileDevice = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
